import React from "react";
import { ArrowRight, ShieldCheck, Star } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { heroImages, company } from "../mock";

const Hero = () => {
  const { t, lang } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="inicio" className="relative pt-[76px] overflow-hidden bg-white">
      <div className="absolute inset-0 hero-grid opacity-60" />
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full blur-3xl opacity-20" style={{ background: "var(--zd-red)" }} />
      <div className="absolute bottom-0 -left-24 h-80 w-80 rounded-full blur-3xl opacity-10" style={{ background: "var(--zd-gold)" }} />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center py-16 md:py-24">
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-px w-8" style={{ background: "var(--zd-gold)" }} />
            <span className={`text-xs font-bold uppercase tracking-[0.18em] ${lang === "zh" ? "font-zh tracking-normal" : ""}`} style={{ color: "var(--zd-red)" }}>{t.hero.badge}</span>
            <span className="h-px w-8" style={{ background: "var(--zd-gold)" }} />
          </div>

          <h1 className={`font-display font-extrabold text-4xl md:text-6xl leading-[1.05] tracking-tight text-balance ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-ink)" }}>
            {t.hero.title1}<br />
            <span style={{ color: "var(--zd-red)" }}>{t.hero.title2}</span>
          </h1>

          <p className={`mt-6 text-lg leading-relaxed max-w-xl ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-slate)" }}>
            {t.hero.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <button onClick={() => scrollTo("contacto")} className="btn-red inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold">
              {t.hero.ctaPrimary} <ArrowRight className="h-4 w-4" />
            </button>
            <button onClick={() => scrollTo("servicios")} className="btn-outline inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold">
              {t.hero.ctaSecondary}
            </button>
          </div>

          <div className="mt-10 flex items-center gap-6">
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-5 w-5" style={{ color: "var(--zd-gold)" }} />
              <span className="text-sm font-medium" style={{ color: "var(--zd-slate)" }}>中文 / Español</span>
            </div>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" style={{ color: "var(--zd-gold)" }} />)}
              <span className="ml-1 text-sm font-medium" style={{ color: "var(--zd-slate)" }}>500+</span>
            </div>
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: ".15s" }}>
          <div className="relative rounded-[28px] overflow-hidden shadow-2xl">
            <img src={heroImages.hero} alt="ZD Consulting" className="w-full h-[440px] md:h-[520px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl px-6 py-4 animate-float">
            <div className="font-display font-extrabold text-2xl" style={{ color: "var(--zd-red)" }}>20+</div>
            <div className="text-xs font-medium" style={{ color: "var(--zd-slate)" }}>{lang === "zh" ? "年专业经验" : "Años de experiencia"}</div>
          </div>
          <div className="absolute -top-5 -right-4 bg-white rounded-2xl shadow-xl px-5 py-3 hidden md:flex items-center gap-3 animate-float" style={{ animationDelay: "1.2s" }}>
            <div className="h-9 w-9 rounded-lg grid place-items-center text-white font-zh font-bold" style={{ background: "var(--zd-gold)" }}>墨</div>
            <div className="text-xs font-semibold" style={{ color: "var(--zd-ink)" }}>Ciudad de México</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
